import React from "react";
import { Routes, Route } from "react-router-dom";
import HeaderRentalBooking from "../Components/Rental Booking/headerRentalBooking";
import ListRentalBookings from "../Components/Rental Booking/listRentalBooking";
import ListRequestPaymentsRefund from "../Components/Rental Booking/requestPaymentRefund";
import ListRentalPayment from "../Components/Rental Booking/listRentalPayment";
import ViewRentalBooking from "../Components/Rental Booking/viewRentalBooking";

const RentalBookingRoutes = () => {
  return (
    <Routes>
      <Route
        path="/rental_booking"
        element={<HeaderRentalBooking></HeaderRentalBooking>}
      ></Route>
      <Route
        path="/rental_booking_list"
        element={<ListRentalBookings></ListRentalBookings>}
      ></Route>
      <Route
        path="/payment_list"
        element={<ListRequestPaymentsRefund></ListRequestPaymentsRefund>}
      ></Route>
      <Route
        path="/rental_payment"
        element={<ListRentalPayment></ListRentalPayment>}
      ></Route>
      <Route
        path="/rental_booking/view/:id"
        element={<ViewRentalBooking></ViewRentalBooking>}
      ></Route>
    </Routes>
  );
};

export default RentalBookingRoutes;